export { default } from "./elaReadingSkillsMapping";
